import React, {useEffect, useMemo, useState} from "react";
import {toast} from "react-toastify";
import {useDefaultEndpoints} from "../../api/useDefaultEndpoints";

const useGetTypeExpenses = (filter) => {
    const {getEntries} = useDefaultEndpoints('type-expenses');
    const [data, setData] = useState([]);

    useEffect(() => {
        getEntries().then(res => {
            setData(() => res);
        }).catch(toast.error)
    }, [])

    return useMemo(() => {
        if (!filter) return data;
        return data.filter(item => item.visibility?.includes(filter));
    }, [data, filter]);
}

export default useGetTypeExpenses;